import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import {
  Link, TranslationProvider, getTranslation, utils,
} from '@resy/ui-kitchen';

import './Ribbon.scss';

function Ribbon({
  Analytics, className, items, isConcierge, isGlobalDiningAccess,
}) {
  if (!items) return null;

  const handleClick = (item) => {
    if (item.isGlobalDiningAccess && !isGlobalDiningAccess) {
      Analytics?.event('view gda module', {
        context: utils.getPageContext(window.location.pathname),
        type: 'non GDA',
      });
    }
    item.onClick?.();
  };

  return (
    <div
      className={cx('Ribbon', className)}
      role="tablist"
      aria-label={getTranslation(
        {
          translationKey: 'sub_navigation',
          fallback: 'Sub navigation',
        }
      )}
    >
      { items.map((item) => {
        if (item.isConcierge && !isConcierge) return false;

        return (
          <TranslationProvider translationKey={item.translationKey} key={item.name}>
            <Link
              role="tab"
              className={cx(
                'Ribbon__Link',
                { 'Ribbon__Link--active': item.isSelected }
              )}
              onClick={() => handleClick(item)}
              href={item.path ? item.path : null}
              aria-selected={item.isSelected}
            >
              {item.name}
            </Link>
          </TranslationProvider>
        );
      })}
    </div>
  );
}

Ribbon.propTypes = {
  Analytics: PropTypes.shape({
    event: PropTypes.func,
  }).isRequired,
  className: PropTypes.string,
  isConcierge: PropTypes.bool,
  isGlobalDiningAccess: PropTypes.bool,
  items: PropTypes.arrayOf(PropTypes.shape({
    isSelected: PropTypes.bool,
    name: PropTypes.string,
    onClick: PropTypes.func,
    path: PropTypes.string,
    translationKey: PropTypes.string,
  })),
};

Ribbon.defaultProps = {
  className: undefined,
  isConcierge: false,
  isGlobalDiningAccess: false,
  items: null,
};

export default Ribbon;
